// extracted by mini-css-extract-plugin
module.exports = {"root":"KnowledgeBaseForm_root__10UDx","publish":"KnowledgeBaseForm_publish__Xdo-q"};